import { useRef } from "react";
import { cerrarSesion } from "Services/functions_service";

export const useTokenExpiration = () => {
  const timeoutRef = useRef(null);

  /**
   * Extrae la fecha de expiración de un token JWT
   * @param {string} token - Token JWT
   * @returns {number|null} Tiempo de expiración en milisegundos o null si es inválido
   */
  const getTokenExpiration = (token) => {
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp * 1000;
    } catch {
      return null;
    }
  };

  /**
   * Inicia el temporizador para cerrar sesión automáticamente cuando expire el token
   * @param {Object} user - Objeto usuario que contiene el token
   */
  const startTokenTimer = (user) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (!user?.token) return;

    const expirationTime = getTokenExpiration(user.token);
    if (!expirationTime) return;

    const currentTime = Date.now();
    const timeUntilExpiration = expirationTime - currentTime;

    if (timeUntilExpiration <= 1000) {
      cerrarSesion({
        titulo: "Sesión Expirada",
        mensaje:
          "Tu sesión ha expirado, por favor inicia sesión para poder acceder a todas las funcionalidades",
      });
      return;
    }

    timeoutRef.current = setTimeout(() => {
      cerrarSesion({
        titulo: "Sesión Expirada",
        mensaje:
          "Tu sesión ha expirado, por favor inicia sesión para poder acceder a todas las funcionalidades",
      });
    }, timeUntilExpiration);
  };

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return { startTokenTimer, clearTimer };
};
